import styled from 'styled-components';

export const ChapterWrapper = styled.div`
  background-color: ${p => p.theme.backgroundColor};
  background-image: ${p => p.theme.backgroundImage};
  background-position: center;

  /*
    For desktop and tablet, we set the height and overflow so that the background stays fixed.
    For mobile, we don't because we want the page to scroll so that the address and nav bars hide.
  */
  ${({ isMobileDevice }) => !isMobileDevice && `
      height: 100%;
      overflow: auto;
      -webkit-overflow-scrolling: touch; /* Needed for momentum-based scrolling behavior on tablet */
  `}
`;
